import { Produto } from '../shared/entity/Produto';
import { FindManyReq, FindOneReq } from '../shared/types/TypeormTypes';
import api from './api';
import { SERVER_URL } from '../shared/constants';
import Categoria from '../shared/entity/Categoria';
import { GetManyParams, GetOneParams } from '../shared/types/TypeormTypes';

const BASE_URL = '/produto';

class produtoApi {
  async getMany(query: GetManyParams<Produto>) {
    try {
      let res = await api.post<Produto[]>(BASE_URL + '/get', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getOne(query: GetOneParams<Produto>) {
    try {
      let res = await this.getMany({ ...query, take: 1 });
      if (!res.length) {
        throw new Error('Produto não encontrado.');
      }
      return res[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getCardapio(empresaId: number) {
    try {
      if (!empresaId) {
        throw new Error('Informe a empresa.');
      }
      let res = await api.get<Categoria[]>(BASE_URL + '/cardapio', {
        params: { empresaId: empresaId }
      });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getImagem(id: number) {
    try {
      let res = await api.get(BASE_URL + '/imagem', {
        params: { id },
        responseType: 'arraybuffer'
      });

      let blob = new Blob([res.data], {
        type: res.headers['content-type']
      });

      let imagem = new File([blob], 'produto.png');

      return imagem;
    } catch (error) {
      console.log(error);
      // throw error;
    }
  }

  async getListaSegundoSabor(id: number) {
    try {
      let res = await api.get<Categoria[]>(BASE_URL + '/segundoSabor', {
        params: { id }
      });

      return res.data;
    } catch (error) {
      console.log(error);
      // throw error;
    }
  }

  async verificarImagem(id: number) {
    try {
      let res = await api.get(BASE_URL + '/imagem', {
        params: { id }
      });
      return true;
    } catch (error) {
      return false;
    }
  }

  getUrlImagem(id: number) {
    return `${SERVER_URL}${BASE_URL}/imagem?id=${id}`;
  }
}

export default new produtoApi();
